import { render, staticRenderFns } from "./fileDownload.vue?vue&type=template&id=55e66774&scoped=true"
import script from "./fileDownload.vue?vue&type=script&lang=js"
export * from "./fileDownload.vue?vue&type=script&lang=js"
import style0 from "./fileDownload.vue?vue&type=style&index=0&id=55e66774&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e66774",
  null
  
)

export default component.exports